import React from 'react';
import { Modal } from '@mairistem/composants';
import { toast } from 'react-toastify';
import { ParametreGeneralEntite } from '@mairistem/comptabilite';
import { isNil, isEmpty } from 'lodash';
import ProfilEcritureList from './ProfilEcritureList';
import ProfilEcriture from '../../../../interfaces/pieces/mouvements/profilEcriture';
import { GroupeProfilEcriture } from '../../../../constants/mouvements/groupesProfilEcriture';
import { getProfilsEcritureFrequent }
  from '../../../../services/piecesComptables/profilEcritures/profileEcrituresFrequents';

interface ProfilEcritureModalProps {
  allProfils: ProfilEcriture[];
  entite: ParametreGeneralEntite;
  groupeProfilEcriture: GroupeProfilEcriture;
  onSelect: any;
  sens: string;
  [x: string]: any;
}

const TYPES = {
  FREQUENTS: 'FREQUENTS',
  TOUS: 'TOUS',
};

const ProfilEcritureModal = ({
  allProfils,
  entite,
  groupeProfilEcriture,
  onSelect,
  sens,
  ...rest
}: ProfilEcritureModalProps) => {
  const [type, setType] = React.useState(TYPES.FREQUENTS);
  const [frequentsList, setFrequentsList] = React.useState([]);
  const [loading, setLoading] = React.useState(false);
  const [loaded, setLoaded] = React.useState(false);

  // Chargement des profils d'écriture fréquents.
  const handleMount = () => {
    if (!loaded && !isNil(entite?.identifiantEntite)) {
      setLoading(true);
      const searchParams = new URLSearchParams();

      if (!isEmpty(sens)) {
        searchParams.append('sens', sens);
      }

      searchParams.append('groupes[]', groupeProfilEcriture?.code);
      searchParams.append('identifiantEntite', entite?.identifiantEntite?.toString());
      searchParams.append('withProfil', 'true');
      searchParams.append('all', 'true');

      getProfilsEcritureFrequent(searchParams)
        .then(({ data }) => {
          setFrequentsList(data);
          setLoaded(true);
        }).catch(() => {
          toast.error("Impossible de récupérer les profils d'écriture fréquent");
        }).finally(() => {
          setLoading(false);
        });
    }
  };

  const handleSelect = (e, profil) => onSelect?.(e, { result: profil });

  const handleTypeChange = (e, { value }) => setType(value);

  return (
    <Modal
      {...rest}
      closeIcon
      size="small"
      onMount={handleMount}
    >
      <Modal.Header content="Profils d'écritures" />
      <Modal.Content>
        <ProfilEcritureList
          onSelect={handleSelect}
          onTypeChange={handleTypeChange}
          type={type}
          items={type === TYPES.FREQUENTS ? frequentsList : allProfils}
          loading={loading}
        />
      </Modal.Content>
    </Modal>
  );
};

export default ProfilEcritureModal;
